import { createCrudSlice } from '@crm/features/crudSliceFactory';

const module = createCrudSlice({
  name: 'crmClients',
  path: 'clients',
  singleKey: 'client',
});

export const clientsActions = module.actions;
export const clientsThunks = module.thunks;
export const clientsSelectors = module.selectors;
export default module.reducer;
